import axios from 'axios';

const API = process.env.REACT_APP_API || '';

const api = axios.create({ baseURL: API, timeout: 30000 });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    config.headers = {
        ...config.headers,
        Authorization: token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json',
        Accept: 'application/json',
    };
    return config;
});

export const accountingApi = {
    meta: () => api.get('/accounting/meta').then((r) => r.data),
    getRucCompany: (id) => api.get(`/accounting/ruc-companies/${id}`).then((r) => r.data),
    saveRucCompany: (data) => api.post('/accounting/ruc-companies', data).then((r) => r.data),
    testSunatConfiguration: (id) => api.post(`/accounting/ruc-companies/${id}/validate-sunat`).then((r) => r.data),
    testGreConfiguration: (id) => api.post(`/accounting/ruc-companies/${id}/validate-gre`).then((r) => r.data),
    saveCatalog: (type, data) => api.post(`/accounting/catalog/${type}`, data).then((r) => r.data),
    deleteCatalog: (type, id) => api.delete(`/accounting/catalog/${type}/${id}`).then((r) => r.data),
    listMovements: (params) => api.get('/accounting/movements', { params }).then((r) => r.data),
    createMovement: (data) => api.post('/accounting/movements', data).then((r) => r.data),
    updateMovement: (id, data) => api.put(`/accounting/movements/${id}`, data).then((r) => r.data),
    cancelMovement: (id) => api.delete(`/accounting/movements/${id}`).then((r) => r.data),
    createTransfer: (data) => api.post('/accounting/transfers', data).then((r) => r.data),
    dashboard: (params) => api.get('/accounting/dashboard', { params }).then((r) => r.data),
    scheduledPayments: () => api.get('/accounting/scheduled-payments').then((r) => r.data),
};
